import type { NativeInvoiceLineAccounting } from "@common/schemas/domains/invoice/native-invoice.schema";
import type { NativeInvoiceLineCodingByLineId } from "./nativeInvoiceFormTypes";

function accountIdFromOverrides(
    overrides:
        | Array<{ accountingLedgerId: string; accountId: string | null }>
        | undefined,
    ledgerId: string | undefined,
): string | null {
    if (!overrides || !ledgerId) {
        return null;
    }
    const entry = overrides.find(
        (override) => override.accountingLedgerId === ledgerId,
    );
    return entry?.accountId ?? null;
}

export function lineCodingFromTemplateAccounting({
    lineAccounting,
    primaryAccrualLedgerId,
    incomeAccountLedgerId,
}: {
    lineAccounting: NativeInvoiceLineAccounting;
    primaryAccrualLedgerId?: string;
    incomeAccountLedgerId?: string;
}): NativeInvoiceLineCodingByLineId {
    const incomeLedgerId = incomeAccountLedgerId ?? primaryAccrualLedgerId;
    return Object.fromEntries(
        lineAccounting.map((entry) => [
            entry.lineId,
            {
                classIds: entry.classIds ?? [],
                accrualAccountId: accountIdFromOverrides(
                    entry.accountOverrides,
                    incomeLedgerId,
                ),
                receivablesAccountId: accountIdFromOverrides(
                    entry.accountsReceivableOverrides,
                    primaryAccrualLedgerId,
                ),
            },
        ]),
    );
}
